<template>
  <SignUp />
</template>

<script lang="js">
import SignUp from '@/components/signup/index.vue'

export default {
  name: 'SignUpPage',
  components: {
    SignUp,
  }
}
</script>
<style lang="scss">
</style>